import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAccounts } from '../context/AccountsContext';
import { useCrmHost } from '../crm/CrmHostContext';
import { useWorkspace } from '../workspace/WorkspaceProvider';
import { homePath } from './sidebarNav';
import { Spinner } from './Spinner';

/** Never keep someone on a spinner because the CRM gate is slow: fall back to the Dashboard. */
const CRM_WAIT_MS = 4000;

/** Where "/" lands (ADR 0031): the Dashboard, or Workspace for a CRM-only login. */
export function HomeRedirect() {
  const { t } = useTranslation('common');
  const { accounts, loaded } = useAccounts();
  const crm = useCrmHost();
  const workspace = useWorkspace();
  const [gaveUp, setGaveUp] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setGaveUp(true), CRM_WAIT_MS);
    return () => clearTimeout(timer);
  }, []);

  const path = gaveUp
    ? '/dashboard'
    : homePath(
        {
          hasConsoleAccounts: loaded ? accounts.length > 0 : null,
          crmOk: crm.access.state === 'ok',
          workspaceEnabled: workspace.enabled,
        },
        crm.access.state !== 'loading',
      );

  if (path) return <Navigate to={path} replace />;
  return (
    <div className="flex flex-col items-center justify-center h-[calc(100*var(--om-vh))] gap-4">
      <Spinner size={40} label={t('loading')} />
    </div>
  );
}
